module.exports = __webpack_public_path__ + "media/images/doctor_full-f8dd969e90270a768808995891a58a36.png";